import { BRAND_TYPE, BRAND_TYPE_LABEL } from 'constants/brands';
import Brand from 'data/Brand';
import { stripHtmlTags } from './formatters';
import { Background, Border, Main } from 'styles/themeColors';

export const getValueCount = (brand: Brand, key: keyof Brand): number => {
  let value = brand[key];

  if (value instanceof Array) {
    return value.length;
  }

  if (key === 'description' && brand[key]) {
    value = brand[key].replace(/<[^>]*>/g, ' ');
  }

  if (typeof value === 'string') {
    return value
      .split(/\s+/)
      .map(word => word.trim())
      .filter(word => word.length > 0).length;
  }

  if (value) {
    return 1;
  }

  return 0;
};

export const mapBrandVendorToBrand = (result: any) => {
  const brandVendor = {
    baseUrl: result.brandVendor.baseUrl || '',
    authenticationUrl: result.brandVendor.authenticationUrl || '',
    consumerKey: result.brandVendor.consumerKey || '',
    consumerSecret: result.brandVendor.consumerSecret || '',
    isMaterialApiEnabled: result.brandVendor.isMaterialApiEnabled || '',
    isStockApiEnabled: result.brandVendor.isStockApiEnabled || '',
    isSalesOrderApiEnabled: result.brandVendor.isSalesOrderApiEnabled || '',
  };

  return brandVendor;
}

export const validateBrandName = (name: string) => {

  const errors: any = {};
  if (name.trim().length === 0) {
    errors.name = 'Field cannot be blank';
  } else if (name.trim().length > 50) {
    errors.name = 'Max 50 characters allowed';
  }

  return errors;
}

export const validateBrandDescription = (description: string) => {

  const errors: any = {};

  // Strip HTML tags
  let plainTextContent = stripHtmlTags(description);

  if (plainTextContent?.trim().length > 5000) {
    errors.description = 'Max 5000 characters allowed';
  }

  return errors;
}

export const validateBrandTitle = (title: string) => {

  const errors: any = {};

  if (title?.trim().length > 1000) {
    errors.title = 'Max 1000 characters allowed';
  }

  return errors;
}

export const validateBrandSEODescription = (seoDescription: string) => {

  const errors: any = {};

  if (seoDescription?.trim().length > 5000) {
    errors.seoDescription = 'Max 5000 characters allowed';
  }

  return errors;
}

export const validateBrandSEOTitle = (seoTitle: string) => {

  const errors: any = {};

  if (seoTitle?.trim().length > 1000) {
    errors.seoTitle = 'Max 1000 characters allowed';
  }

  return errors;
}

export const validateBrandData = (brand: any) => {
  let isValid = true;
  let errors: any = {};

  const nameErrors = validateBrandName(brand.name);
  const descriptionErrors = validateBrandDescription(brand.description);
  const titleErrors = validateBrandTitle(brand.title);
  const seoTitleErrors = validateBrandSEOTitle(brand.seoTitle);
  const seoDescriptionErrors = validateBrandSEODescription(brand.seoDescription);

  if (Object.keys(nameErrors).length > 0) {
    isValid = false;
    errors = { ...errors, ...nameErrors };

  }

  if (Object.keys(descriptionErrors).length > 0) {
    isValid = false;
    errors = { ...errors, ...descriptionErrors };

  }

  if (Object.keys(titleErrors).length > 0) {
    isValid = false;
    errors = { ...errors, ...titleErrors };

  }

  if (Object.keys(seoTitleErrors).length > 0) {
    isValid = false;
    errors = { ...errors, ...seoTitleErrors };

  }

  if (Object.keys(seoDescriptionErrors).length > 0) {
    isValid = false;
    errors = { ...errors, ...seoDescriptionErrors };

  }

  // Br.empty seeds a placeholder media entry with id 0, so check for a real upload.
  if (!brand.media?.[0]?.id) {
    isValid = false;
    errors.media = 'Brand logo is required';
  }

  return { isValid, errors };
}

export const mapBrandTypeBackground = (type: string) => {
  switch (type) {
    case BRAND_TYPE.BRAND:
      return Main.lightBlue;

    case BRAND_TYPE.PARENT_BRAND:
      return Background.lightBrand;

    case BRAND_TYPE.SUB_BRAND:
      return Main.lightBlue;

    default:
      return Main.lightBlue;
  }
}

export const mapBrandTypeBorder = (type: string) => {
  switch (type) {
    case BRAND_TYPE.BRAND:
      return Main.lightGray;

    case BRAND_TYPE.PARENT_BRAND:
      return Border.brand;

    case BRAND_TYPE.SUB_BRAND:
      return Main.lightGray;

    default:
      return Main.lightGray;
  }
}

export const mapBrandTypeColor = (type: string) => {
  switch (type) {
    case BRAND_TYPE.BRAND:
      return Main.accent;

    case BRAND_TYPE.PARENT_BRAND:
      return Main.brandDarkest;

    case BRAND_TYPE.SUB_BRAND:
      return Main.accent;

    default:
      return Main.accent;
  }
}

export const mapBrandTypeLabel = (type: string) => {
  switch (type) {
    case BRAND_TYPE.BRAND:
      return BRAND_TYPE_LABEL.BRAND;

    case BRAND_TYPE.PARENT_BRAND:
      return BRAND_TYPE_LABEL.PARENT_BRAND;

    case BRAND_TYPE.SUB_BRAND:
      return BRAND_TYPE_LABEL.SUB_BRAND;

    default:
      return BRAND_TYPE_LABEL.BRAND;
  }
}